var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.kV=require("crc-32");module.exports=$CLJS.kV;